var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"border-0",attrs:{"no-body":""}},_vm._l((_vm.videos),function(vidset,i){return _c('b-row',{key:'vidset-' + i},_vm._l((vidset),function(vid,j){return _c('b-col',{key:'vid-' + j,attrs:{"md":"3"}},[_c('training-video',{attrs:{"title":vid.title,"src":_vm.getSrc(vid),"poster":_vm.getPoster(vid)}})],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }